@if (isImpersonated$ | async) {
  <div class="impersonation-header">
    <div (click)="finishImpersonation()">Impersonated as {{ (user$ | async).email }}</div>
  </div>
}
<router-outlet></router-outlet>
